module.exports = __webpack_public_path__ + "src/assets/textures/env/wagon/wagon_hitch_512_bake.png";